import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "../components/styles/Servicesec.css";

import s1 from "../assets/productsec/s1.jpeg";
import s2 from "../assets/productsec/s2.jpeg";
import s3 from "../assets/productsec/s3.jpeg";
import s4 from "../assets/productsec/s4.avif";
import s5 from "../assets/productsec/s5.jpeg";
import s6 from "../assets/productsec/s6.avif";

function Services() {
  const services = [
    {
      title: "Residential Cleaning",
      description:
        "Professional home cleaning services to keep your living space spotless, fresh, and hygienic.",
      image: s1,
    },
    {
      title: "Commercial Cleaning",
      description:
        "Comprehensive cleaning solutions for offices, retail stores, and business premises.",
      image: s2,
    },
    {
      title: "Industrial Cleaning",
      description:
        "Specialized cleaning for factories, warehouses, and industrial facilities ensuring a safe environment.",
      image: s3,
    },
    {
      title: "Specialized Cleaning",
      description:
        "Deep cleaning services tailored for hospitals, laboratories, and sensitive environments.",
      image: s4,
    },
    {
      title: "Maintenance Services",
      description:
        "Routine maintenance and janitorial services to ensure clean and well-maintained spaces.",
      image: s5,
    },
    {
      title: "Sanitization Services",
      description:
        "Effective sanitization and disinfection services to eliminate germs and ensure hygiene.",
      image: s6,
    },
  ];

  return (
    <section className="services-section py-5">
      <Container>
        <div className="text-center mb-5">
          <h3 className="section-subtitle">Our Services</h3>
          <h3 className="section-title">World-Class Cleaning Services</h3>
          <div className="divider mx-auto"></div>
        </div>
        <Row>
          {services.map((service, index) => (
            <Col lg={4} md={6} className="mb-4" key={index}>
              <Card className="service-card h-100">
                <div className="service-img-container">
                  <Card.Img variant="top" src={service.image} className="service-img" />
                </div>
                <Card.Body className="product-cardbody">
                  <Card.Title className="service-title">{service.title}</Card.Title>
                  <Card.Text className="service-text">{service.description}</Card.Text>
                </Card.Body>
                <Card.Footer className=" border-0 pb-4 text-center product-cardbody">
                  <Button variant="primary" className="read-more-btn">
                    Read more
                  </Button>
                </Card.Footer>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default Services;
